<script lang="ts" setup>
  import { ref, watch, nextTick } from 'vue';
  import { useNotificationsStore } from '@/common/store/pinia/notifications';
  import BottomNotification from '@/common/components/notification-center/BottomNotification.vue';
  import { storeToRefs } from 'pinia';

  const GAP = 16;

  type TypeBottomNotification = InstanceType<typeof BottomNotification>;

  const notificationsStore = useNotificationsStore();
  const { bottomNotifications } = storeToRefs(notificationsStore);
  const notificationRef = ref<TypeBottomNotification[] | null>(null);

  watch(bottomNotifications, async (notifications) => {
    if (!notifications.length) return;

    // Wait all ticks to ensure that notifications are rendered
    // and have their height calculated
    await nextTick();
    await nextTick();

    notificationRef.value?.forEach((instance, index, arr) => {
      const offset = arr.slice(0, index).reduce(
        (acc, it) => acc + (it.$el as HTMLElement).offsetHeight + GAP, GAP
      );
      (instance.$el as HTMLElement).style.bottom = `${offset}px`;
    });
  }, { immediate: true });
</script>

<template>
  <div class="v-bottom-notifications">
    <bottom-notification
      v-for="notification in bottomNotifications"
      :key="notification.id"
      ref="notificationRef"
      :notification="notification"
    />
  </div>
</template>
